// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35Ene","label":"styles_label__2qW2_"};